import { MessageBarType } from "@fluentui/react";
import { fetchMenuAsync } from "../Menu";
import BlobStorageService from "./BlobStorageService";
import { v4 as uuid4 } from "uuid";

export const putMenu = async (menu, setMenuContext) => {
  BlobStorageService.save(
    "",
    window.configs.STORAGE_ACCOUNT_MENUBLOB ?? "menu.json",
    JSON.stringify({ menu: menu }, null, 2)
  )
    .then(() =>
      setMenuContext((prevState) => ({
        ...prevState,
        menuEditStateDisplay: true,
        menuEditStateSeverity: MessageBarType.success,
        menuEditStateMessage: "Menu changes successfully saved.",
        menuEditStateId: uuid4().toString(),
      }))
    )
    .then(() => fetchMenuAsync(setMenuContext))
    .catch((e) => {
      setMenuContext((prevState) => ({
        ...prevState,
        menuEditStateDisplay: true,
        menuEditStateSeverity: MessageBarType.error,
        menuEditStateMessage: `${e.statusCode} ${e.message}`,
        menuEditStateId: uuid4().toString(),
      }));
    });
};
